import changeToAnalyticsFormat from "./changeToAnalyticsFormat";

export const getAnalyticsAttribute = {
  Make: "make",
  Model: "model",
  Eligibility: "transportEligibility",
  Payment: "paymentStatusFilter",
};

const getFilterAnalytics = (
  listOfFilters: {
    filterKey: string;
    categoryKey: string;
  }[],
  removedFilter?: any
) => {
  if (!Boolean(listOfFilters)) return null;

  const categoryKeysList = listOfFilters?.map((item) => {
    return item.categoryKey;
  });

  const lastSelectedFilter = removedFilter
    ? removedFilter?.categoryKey
    : categoryKeysList[categoryKeysList.length - 1];
  const filterToUpdate = getAnalyticsAttribute[lastSelectedFilter];

  let search = {
    filter: removedFilter ? "" : filterToUpdate,
  };

  search[filterToUpdate] = listOfFilters
    .filter((item) => item.categoryKey === lastSelectedFilter)
    .map((item) => changeToAnalyticsFormat(item.filterKey))
    .flat()
    .join(",");

  return search;
};

export default getFilterAnalytics;
